import avatar1 from "assets/images/avatars/avatar1.png";
import avatar2 from "assets/images/avatars/avatar2.png";
import avatar3 from "assets/images/avatars/avatar3.png";
import avatar4 from "assets/images/avatars/avatar4.png";
// import { Fade } from "react-awesome-reveal";
import { FiveStar } from "utils/Icons";
// slick slider
import Slider from "react-slick";

//
const Testimonial = () => {
  // slider settings / config
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  //   testimonial data
  let testimonialData = [
    {
      img: avatar1,
      name: `Jennifer R.`,
      desc: `I absolutely love this app. I love the variety and the emergency sessions. It helped with my anger and yelling.`,
    },
    {
      img: avatar2,
      name: `Sofia B.`,
      desc: `This has been one of the most important apps in my daily routine. I love it! I’ve noticed a big change in me fast.`,
    },
    {
      img: avatar3,
      name: `Camilia F.`,
      desc: `A must-have for all moms out there! I have 2 small kids and this app has really helped me to be calmer & relaxed.`,
    },
    {
      img: avatar4,
      name: `Jessica S.`,
      desc: `Need more stars please!!! Downloaded it less than 24 hours ago and I see and feel the change already!!! A MUST KEEP.`,
    },
  ];
  return (
    <div className="testimonial_wrapper">
      {/* <Fade triggerOnce delay={700} duration={1600}> */}
        <h3>Member Success Stories</h3>
      {/* </Fade> */}
      <br />
      {/*  */}
      {/* <Fade triggerOnce delay={850} duration={1600}> */}
        <Slider {...settings}>
          {testimonialData?.map((item, index) => (
            <div key={index}>
              <div className="testimonial_card d_flex">
                <div className="testimonial_avatar">
                  <img src={item?.img} alt="" width="45" height="45"/>
                </div>
                <div className="testimonial_card_body">
                  <p>{item?.desc}</p>
                  <div className="d_flex align_items_center justify_content_start">
                    <div className="client_name">
                      <h6>{item?.name}</h6>
                    </div>
                    <FiveStar />
                    <FiveStar />
                    <FiveStar />
                    <FiveStar />
                    <FiveStar />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      {/* </Fade> */}
    </div>
  );
};

export default Testimonial;
